module.exports = __webpack_public_path__ + "static/media/login-background.0214db7a.png";